import { render } from "./AddStaffModal.vue?vue&type=template&id=252099d6&scoped=true"
import script from "./AddStaffModal.vue?vue&type=script&lang=js"
export * from "./AddStaffModal.vue?vue&type=script&lang=js"

import "./AddStaffModal.vue?vue&type=style&index=0&id=252099d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252099d6"]])

export default __exports__